import type {KeyValue} from '@jetbrains/teamcity-ui/dist/utils'
import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'

import type {UserProperty} from '../utils/userProperties'

const initialState: KeyValue<UserProperty, string> = {}
export const fallbackUserProperties = createSlice({
  name: 'fallbackUserProperties',
  initialState,
  reducers: {
    set(state, action: PayloadAction<{name: UserProperty; value: string}>) {
      const {name, value} = action.payload
      state[name] = value
    },
  },
})
